import { Alert, Box, Text } from '@factorialco/deprecated-design-system'

export const SerialSequencesPreviewBox = ({
  name,
  preview,
}: {
  name?: string
  preview: string
}) => {
  return (
    <Alert>
      <Box flexDirection="column" gap="s0">
        <Text.Normal size="200" weight="medium" color="grey700">
          {name ?? 'Preview'}
        </Text.Normal>
        <Text.Normal size="300" color="grey1000">
          {preview}
        </Text.Normal>
      </Box>
    </Alert>
  )
}
